import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function LandingNav() {
  const location = useLocation();
  const hashLink = (hash) => (location.pathname === "/" ? hash : `/${hash}`);

  return (
    <header className="saas-lp-nav">
      <div className="saas-lp-inner saas-lp-nav__inner">
        <Link to="/" className="saas-lp-brand">
          <span className="saas-lp-brand__icon">b</span>
          <span className="saas-lp-brand__text">
            <strong>Beentara</strong>
            <small>Built for growth</small>
          </span>
        </Link>

        <nav className="saas-lp-nav__links">
          <a href={hashLink("#ecosystem")}>Ecosystem</a>
          <a href={hashLink("#pricing")}>Pricing</a>
          <a href={hashLink("#vision")}>Our Vision</a>
          <Link to="/contact">Contact</Link>
        </nav>

        <div className="saas-lp-nav__actions">
          <Link to="/login" className="saas-lp-nav__login">
            Login
          </Link>
          <Link to="/signup" className="saas-btn saas-btn--primary saas-lp-nav__cta">
            Get Started
          </Link>
        </div>
      </div>
    </header>
  );
}
